<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            @searchResource="searchResource" 
            @create="()=>{newResource = {source:'Telephone', email:'no_email'}; dialog = true;}"
          />
        </v-col>
        <v-col cols="12" RECORD>
          <v-card class="px-3" :loading="loading">
            <v-row class="pa-0 align-center">
              <v-col cols="3" class="text-center" style="text-transform:uppercase;">
                <v-progress-circular indeterminate v-if="loading" size="20" color="primary"></v-progress-circular>
                <v-chip label small v-if="resource && resource.counter">{{resource.counter}} {{i18n.leads}}</v-chip>   <span v-if="resource && resource.time" style="font-size:11px;"> {{resource.time.toFixed(1)}} s</span>
              </v-col>
              <v-col cols="3">
                <v-btn block text color="success" :loading="loading"  @click="()=>{newDialog = true;}"
                  :class="`${arabic?'arFont':'enFont'}`"
                >import data</v-btn>
              </v-col>
              <v-col cols="3">
                <v-btn block text color="success" :loading="loading"  @click="()=>{newSectorDialog = true;}"
                  :class="`${arabic?'arFont':'enFont'}`"
                >add sector</v-btn>
              </v-col>
              <v-col cols="3">
                <v-btn block text color="success" :loading="loading"  @click="newEmailDialog = true"
                  :class="`${arabic?'arFont':'enFont'}`"
                >Verify Email</v-btn>
              </v-col>
              
            </v-row>
            <v-row row justify-center IMPORTDIALOG>
              <v-dialog v-model="newDialog" persistent max-width="1000">
                <v-card :loading="loading">
                  <v-card-title class="headline">{{'Add New Leads'}}</v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                        <v-autocomplete
                          :items="programs"
                          v-model="selectedProgram"
                          :label="i18n.program"
                          autocomplete="disabled"
                          outlined
                          :loading="loading"
                          hide-details
                          clearable
                          dense
                          item-value="id"
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                          <template v-slot:selection="{ attr, on, item, selected }">
                            <span
                              v-bind="attr"
                              :input-value="selected"
                              v-on="on"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                            </span>
                          </template>
                          <template v-slot:item="{ item }">
                            <span
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              {{i18n[item.slug]}}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                        <v-autocomplete
                          :items="bundeslands"
                          v-model="selectedBundesland"
                          :label="i18n.bundesland"
                          autocomplete="disabled"
                          outlined
                          hide-details
                          dense
                          :loading="loading"
                          clearable
                          item-value="id"
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                          <template v-slot:selection="{ attr, on, item, selected }">
                            <span
                              v-bind="attr"
                              :input-value="selected"
                              v-on="on"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                            </span>
                          </template>
                          <template v-slot:item="{ item }">
                            <span
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              {{i18n[item.slug]}}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                        <v-autocomplete
                          :items="sectors"
                          v-model="selectedSector"
                          :label="i18n.sector"
                          autocomplete="disabled"
                          outlined
                          hide-details
                          dense
                          :loading="loading"
                          clearable
                          item-value="id"
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                          <template v-slot:selection="{ attr, on, item, selected }">
                            <span
                              v-bind="attr"
                              :input-value="selected"
                              v-on="on"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                            </span>
                          </template>
                          <template v-slot:item="{ item }">
                            <span
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              {{i18n[item.slug]}}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                        <v-menu
                          v-model="menu6"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="toDate"
                              :label="i18n.collectDate"
                              prepend-icon="mdi-calendar"
                              readonly
                              :loading="loading"
                              outlined
                              hide-details
                              dense
                              clearable
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="toDate"
                            @input="menu6 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                        <v-switch label="New?" v-model="isNew" hide-details></v-switch>
                      </v-col>
                      <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-1`">
                        <v-textarea
                          label="Data"
                          outlined
                          clearable
                          :loading="loading"
                          rows="10"
                          clearable-icon="close"
                          dense
                          :class="`${arabic?'arFont':'enFont'}`"
                          v-model="data"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click.native="()=>{
                      newDialog = false; 
                    }" :loading="loading"
                      >cancel
                    </v-btn>
                    
                    <v-btn color="success" :loading="loading" text @click.native="searchBulk()">import</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row row justify-center NEWSECTORDIALOG>
              <v-dialog v-model="newSectorDialog" persistent max-width="1000">
                <v-card :loading="loading">
                  <v-card-title class="headline">{{'Add New SECTOR'}}</v-card-title>
                  <v-card-text>
                    <v-row class="pa-0">
                      <v-col cols="4" class="py-0">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          @keypress="noSpace($event)"
                          :label="i18n.slug"
                          v-model="newSector.slug"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4" class="py-0">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          :label="i18n.english"
                          v-model="newSector.en"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4" class="py-0">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          :label="i18n.german"
                          v-model="newSector.de"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" class="py-1">
                        <v-autocomplete
                          :items="programs"
                          v-model="newSector.program_id"
                          :label="i18n.program"
                          autocomplete="disabled"
                          outlined
                          hide-details
                          clearable
                          dense
                          item-value="id"
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                          <template v-slot:selection="{ attr, on, item, selected }">
                            <span
                              v-bind="attr"
                              :input-value="selected"
                              v-on="on"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <v-chip x-small>{{item.slug}}</v-chip>
                            </span>
                          </template>
                          <template v-slot:item="{ item }">
                            <span
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              {{item.slug}}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click.native="()=>{
                      newSectorDialog = false; 
                    }" :loading="loading"
                      >cancel
                    </v-btn>
                    <v-btn color="success" :loading="loading" text @click.native="addNewSector()">import</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row row justify-center VERIFYEMAILS>
              <v-dialog v-model="newEmailDialog" persistent max-width="1000">
                <v-card>
                  <v-card-title class="headline">Verify Email</v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12" class="py-0">
                        <v-text-field
                          :label="i18n['email']"
                          outlined
                          dense
                          v-model="email"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click.native="newEmailDialog = false">cancel</v-btn>
                    <v-btn color="success" text @click.native="verifyEmail()">verify</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" FILTERS>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0">
                
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="programs"
                    v-model="selectedProgram"
                    :label="i18n.program"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    clearable
                    dense
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{i18n[item.slug]}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="bundeslands"
                    v-model="selectedBundesland"
                    :label="i18n.bundesland"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    dense
                    clearable
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{i18n[item.slug]}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="sectors"
                    v-model="selectedSector"
                    :label="i18n.sector"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    clearable
                    dense
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{i18n[item.slug]}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="usersall"
                    v-model="selectedUser"
                    :label="i18n.employee"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    clearable
                    :filter="filterObject"
                    dense
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{item.name}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{item.name}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fromDate"
                        label="From Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        outlined
                        hide-details
                        dense
                        @change="filterLeads()"
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fromDate"
                      @change="filterLeads()"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="toDate"
                        label="To Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        hide-details
                        outlined
                        @change="filterLeads()"
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="toDate"
                      @change="filterLeads()"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-switch 
                    hide-details
                    clearable
                    dense
                    @change="filterLeads()"
                    label="New Only" 
                    v-model="newOnly">
                  </v-switch>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 align-center mb-1">
                <bwlistPanel
                  :resource="resource"
                  :resourceSettings="resourceSettings"
                  @editLead="editLead"
                  @copyS="clipboardSuccessHandler"
                  @copyF="clipboardErrorHandler"
                  :loading="loading"
                  :resourceKeys="resourceKeys"
                />
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <multiDialog
          :dialog="dialog"
          :loading="loading"
          :resourceSettings="resourceSettings"
          :deleting="deleting"
          :resourceKeys="resourceKeys"
          :newResource="newResource"
          @closeDialog="()=>{dialog = false;newResource={};}"
          @deleteResource="deleteResource"
          @updateResource="updateResource"
          @postResource="postResource"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import bwlistPanel from '@/components/bwlistPanel'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: { Search, Paging, multiDialog, bwlistPanel },
  data() {
    return {
      loading:false,
      dialog:false,
      accepted:false,
      interview:false,
      newDialog:false,
      newEmailDialog:false,
      newSectorDialog:false,
      data:null,
      vresource:[],
      resource:[],
      newSector:{},
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys: [{
              name: 'name',
              label: 'name',
              type: 'text',
              fetched: 'name',
              required: true
          },
          {
              name: 'program_id',
              label: 'program',
              type: 'select',
              items: 'programs',
              fetched: 'program_name',
              data: [],
              source: 'db',
              required: true,
              readonly: true
          },
          {
              name: 'bundesland_id',
              label: 'bundesland',
              type: 'select',
              items: 'bundeslands',
              fetched: 'bundesland_name',
              data: [],
              source: 'db',
              required: true,
              readonly: true
          },
          {
              name: 'email',
              label: 'email',
              type: 'text',
              fetched:'email',
              required: true,
              readonly: true
          },
          {
              name: 'phone',
              label: 'phone',
              type: 'text',
              fetched: 'phone',
              required: true,
              readonly: false
          },
          {
              name: 'user_id',
              label: 'agent',
              type: 'select',
              items: 'usersall',
              fetched: 'user_name',
              data: [],
              source: 'db',
              required: true,
              readonly: true
          },
          {
              name: 'sector_id',
              label: 'sector',
              type: 'select',
              items: 'sectors',
              fetched: 'sector_name',
              data: [],
              source: 'db',
              required: true,
              readonly: false,
          },
          {
              name: 'note',
              label: 'note',
              type: 'textarea',
              fetched: 'note',
          },
      ],
      resourceSettings:{
        resourceName:null,
        search:true,
        create:true,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      programs:[],
      bundeslands:[],
      sectors:[],
      usersall:[],
      selectedUser:null,
      selectedProgram:null,
      selectedBundesland:null,
      selectedSector:null,
      isNew:false,
      menu1:false,
      menu2:false,
      menu3:false,
      menu4:false,
      menu5:false,
      menu6:false,
      menu7:false,
      menu8:false,
      fromDate:null,
      toDate:null,
      email:null,
      match_result:false,
      matchResults:[],
      newOnly:true,
    }
  },
  
  methods: {
    async addNewSector(){

    },
    async verifyEmail(){
      let r = await axios.post(this.api + '/verify-email-25888', {email:this.email}, {headers}).then(x=>x.data)
      this.$emit('snackbarNotification', `An email is sent to ${this.email} please click link inside it`, 'success')
      this.newEmailDialog = false
    },
    noSpace(evt){
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode == 32 || charCode == 19 || charCode == 9) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    async createAndRecord(){
      this.loading = true
      console.log(this.matchResults.data)
      let p = {
        leads:this.matchResults.data,
        date:this.toDate,
        status: this.interview ? 'interview' : this.accepted ? 'accepted' : null
      }
      console.log(p)
      try {
        let s = await axios.post(`${this.api}/leads/create-record`, p, {headers}).then(x=>x.data)
        console.log(s)
      } catch (error) {
        console.log(error)
      }
      
      this.accepted = null
      this.interview = null
      this.selectedProgram = null
      this.toDate = null
      this.data = null
      this.newDialog = false
      this.loading = false
      this.match_result = false
      this.matchResults = []
      this.loadResource()
    },
    async searchBulk(){
      this.loading = true
      console.log(this.selectedSector)
      console.log(this.selectedBundesland)
      console.log(this.selectedProgram)
      console.log(this.toDate)
      console.log(this.data)
      if(!this.data.includes('\n')) {
        this.$emit('snackbarNotification', `Please check data`, 'error')
        this.loading = false
        return true
      }
      let splits = this.data.split('\n').map(x=>x.split("\t").map(y=>y.trim()))
      console.log(splits)
      if(!splits.length) {
        this.$emit('snackbarNotification', `Please check data`, 'error')
        this.loading = false
        return true
      }
      let data = []
      splits.forEach(l=>{
        let lead = {
          email:l[0] != '' ? l[0].replace(/"/g, '').replace(/'/g, '') : null,
        }
        if(lead.email && !data.map(x=>x.email).includes(lead.email) && lead.email.includes('@') && lead.email != '' && lead.email != ' ' && lead.email != '"') {
          data.push(lead)
        }
      })
      if(!data.length) {
        this.$emit('snackbarNotification', `Please check data`, 'error')
        this.loading = false
        return true
      }
      let p = {
        items:data,
        date:this.toDate,
        program:this.selectedProgram,
        bundesland:this.selectedBundesland,
        sector:this.selectedSector,
        new:this.isNew,
      }
      console.log(p)
      let s = await axios.post(`${this.api}/bw-leads/bulk`, p, {headers}).then(x=>x.data)
      this.loading = false
      this.newDialog = false
      this.$emit('snackbarNotification', `Imported | ${data.length}` , 'success')
      console.log(s)
    },
    editLead(r){
      this.dialog = true
      this.editing = true
      this.newResource = r
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async loadItems(){
      return new Promise(async (res, rej)=>{
        let ks = this.resourceKeys.filter(x=>x.type=='select' && x.source == 'db');
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = this.resource[f]
            if(!t.error) {
              let maps = t.map(x=>{
                let t = x.name?x.name:x.company?x.company:x.country?x.country:x.program?x.program:null
                console.log(t)
                return{...x, text:t, [`${f.items}_id`]:x.id}
              })
              f.data = maps
            }
          }
          res(true)
        })()
      })
    },
    getItems(items) {
      return this.resourceKeys.filter(x=>x.items == items)[0].data
    },
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.required}`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.valid_email}`, 'error')
        }
      })
      return v
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadSettingsItems(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let ks = ['bundeslands', 'programs', 'sectors', 'usersall'];
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = this.resource[f]
            console.log('items', f, t)
            if(!t.error)
            t.forEach(x=> this.$store.state.i18n.en[x.slug] = x.en)
            t.forEach(x=> this.$store.state.i18n.ar[x.slug] = x.ar)
            t.forEach(x=> this.$store.state.i18n.fr[x.slug] = x.fr)
            this[f] = t
          }
          let rks = this.resourceKeys.filter(x=>x.type == 'select' && x.source == 'db')
          for (let i = 0; i < rks.length; i++) {
            const rk = rks[i];
            rk.data = this[rk.items].map(x=>{
              let text = x.slug ? this.i18n[x.slug] : x.name
              return{...x, [rk.name + '_id']: x.id, text}
            })
            console.log(rk.data)
          }
          this.loading = false
          res(true)
        })()
      })
    },
    buildFilter(){
      let filter = ``
      
      if(this.selectedProgram) {
        filter += `&filter[program_id]=${this.selectedProgram}`
      }
      if(this.selectedBundesland) {
        filter += `&filter[bundesland_id]=${this.selectedBundesland}`
      }
      if(this.selectedSector) {
        filter += `&filter[sector_id]=${this.selectedSector}`
      }
      if(!this.fromDate) this.fromDate = new Date( new Date().getTime() - 24*60*60*1000 ).toISOString().split('T')[0]
      if(!this.toDate) this.toDate = new Date().toISOString().split('T')[0]
      if(this.fromDate && this.toDate) {
        filter += `&filter[in_between]=${this.fromDate},${this.toDate}`
      }
      if(this.selectedUser) {
        filter += `&filter[user_id]=${this.selectedUser}`
      }
      if(this.newOnly) {
        filter += `&filter[new]=${this.newOnly}`
      }
      return filter
    },
    async filterLeads(){
      await this.loadResource()
    },
    firstLoad(){
      if(this.user && !this.user.hq) {
        console.log(this.user)
      }
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(this.search)
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path + '?' + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        }
        this.loading = false
        let ks = ['bundeslands', 'programs', 'sectors', 'usersall'];
        ks.forEach(k=> this[k]=this.resource[k])
        res()
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}` + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        this.loading = false
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:this.$route.path + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        await this.$store.dispatch('postResource', {resource:this.$route.path + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '').replace('-', '')
    },
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    this.firstLoad()
    await this.loadResource()
    this.loadSettingsItems()
    // await this.loadItems()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>